import React, { useContext } from 'react'

import { ServicesContext } from 'common/builder/components/chart/FlowChart/contexts/ServiceProvider'
import {
  commentText,
  commentTextLarge,
} from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import {
  CommentNodeText,
  CommentNodeTextType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartCommentNode'
import { FontSizeType } from 'common/builder/nodes/comment/commentNodeConstants'

interface CommentNodeContentProps {
  textParts: CommentNodeText[]
  fontSize: FontSizeType
}

const textStyleMap = {
  [FontSizeType.SMALL]: commentText,
  [FontSizeType.LARGE]: commentTextLarge,
}

export const CommentNodeContent = ({ textParts, fontSize }: CommentNodeContentProps) => {
  const textStyle = textStyleMap[fontSize]
  const { commentService } = useContext(ServicesContext)

  return (
    <>
      {textParts.map((textPart, index) => {
        if (textPart.type === CommentNodeTextType.URL) {
          return (
            <view
              onClick={() => {
                commentService?.clickUrl(textPart.value)
              }}
              cursor="pointer"
              style={{ display: 'flex' }}
              key={index}
            >
              <richtext style={textStyle} text={textPart.value} />
            </view>
          )
        }
        return <richtext style={textStyle} text={textPart.value} key={index} />
      })}
    </>
  )
}
